import { render, staticRenderFns } from "./officialPrinting.vue?vue&type=template&id=2318b966&scoped=true"
import script from "./officialPrinting.vue?vue&type=script&lang=js"
export * from "./officialPrinting.vue?vue&type=script&lang=js"
import style0 from "./officialPrinting.vue?vue&type=style&index=0&id=2318b966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318b966",
  null
  
)

export default component.exports